module.exports = __webpack_public_path__ + "static/media/Sol.df518a23.PNG";